module.exports = __webpack_public_path__ + "media/images/bg-points-a8550bbd85863072e05705fa32ae74b1.svg";